import {Component, EventEmitter, Input, Output} from '@angular/core';
import {getEnvBadgeClass} from '../../utils/helpers';

@Component({
    selector: 'app-version-banner',
    templateUrl: './version-banner.component.html',
    styleUrls: ['./version-banner.component.scss'],
})
export class VersionBannerComponent {
    @Input() version: string;
    @Input() versionUrl: string;
    @Input() environment: string;
    @Output() refresh = new EventEmitter<void>();
    @Output() dismiss = new EventEmitter<void>();

    envBadgeClass(): string {
        return getEnvBadgeClass(this.environment);
    }
}
